import React from 'react';
import './HeroBackdrop.scss';

interface HeroBackdropProps {
  imageUrl: string;
}

export const HeroBackdrop: React.FC<HeroBackdropProps> = ({ imageUrl }) => (
  <div className="hero-backdrop">
    <div
      className="hero-backdrop__image"
      style={{ backgroundImage: `url('${imageUrl}')` }}
    />
    <div className="hero-backdrop__overlay" />
    <div className="hero-backdrop__grain" />
  </div>
);
